import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './images/banner-icon.png'
import _imports_1 from './images/banner-text.png'
import _imports_2 from './images/icon-arrow-down.png'


const _withScopeId = n => (_pushScopeId("data-v-0b1f1928"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "banner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "icon"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "",
    class: "text"
  })
], -1))
const _hoisted_5 = { class: "nav-wrapper-scroll" }
const _hoisted_6 = { class: "nav-wrapper" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "text-wrappper" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "sub-icon"
}, null, -1))

import { ref, onMounted } from 'vue';
  import { IEmartProgram } from './type';
  import Tab1 from './components/tab-1.vue';
  import Tab2 from './components/tab-2/index-view.vue';
  import Tab3 from './components/tab-3/index.vue';
  import Tab4 from './components/tab-4.vue';
  import Tab5 from './components/tab-5/index-view.vue';
  import Tab6 from './components/tab-6/index.vue';

  export interface IProps {
    program: IEmartProgram
  }
export default /*#__PURE__*/_defineComponent({
  props: {
    program: { default: () => ({} as IEmartProgram) }
  },
  setup(__props: any) {

  ;

  
  onMounted(() => {});

  // 调试用
  // const program = ref<IEmartProgram>({ id: 0 } as IEmartProgram);
  // onMounted(async () => {
  //   const { request } = require('@/utils/index');
  //   const { data } = await request.get('programs/93');
  //   program.value = data;
  // });

  const activeIndex = ref(0);

  const nav = [
    {
      text: 'ABOUT 가플지우',
    },
    {
      text: '재활용 프로그램',
    },
    {
      text: '이달의 바다',
    },
    {
      text: '가플지우 아카데미',
    },
    {
      text: 'FAQ',
    },
    {
      text: '가플지우 게시판',
    },
  ];

  function handleToggleTabActive(index: number) {
    activeIndex.value = index;
  }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(nav, (item, index) => {
            return _createElementVNode("div", {
              key: index,
              class: _normalizeClass(["item text-center", {active: index === activeIndex.value}]),
              onClick: ($event: any) => (handleToggleTabActive(index))
            }, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.text), 1),
              _hoisted_9
            ], 10, _hoisted_7)
          }), 64))
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(Tab1)
    ], 512), [
      [_vShow, activeIndex.value === 0]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(Tab2, { program: __props.program }, null, 8, ["program"])
    ], 512), [
      [_vShow, activeIndex.value === 1]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(Tab3, { program: __props.program }, null, 8, ["program"])
    ], 512), [
      [_vShow, activeIndex.value === 2]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(Tab4, { program: __props.program }, null, 8, ["program"])
    ], 512), [
      [_vShow, activeIndex.value === 3]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(Tab5)
    ], 512), [
      [_vShow, activeIndex.value === 4]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(Tab6)
    ], 512), [
      [_vShow, activeIndex.value === 5]
    ])
  ]))
}
}

})